import "./components/bab-chart-app";
import type { BabChartApp } from "./components/bab-chart-app";
import type { RatingExport } from "./models";
import { registerSW } from 'virtual:pwa-register';

declare global {
  interface Window {
    getBABRatings(): RatingExport[];
  }
}

registerSW({ immediate: true });

window.getBABRatings = () => {
  const app = document.querySelector("bab-chart-app") as BabChartApp | null;
  return app?.getRatings() ?? [];
};
